<template>
  <google-maps-loader :mapConfig="mapConfig" :apiKey="MAP_KEY">
    <template slot-scope="{ google, map }">
      <google-maps-marker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
        @click="infoWindow(marker.infoWindow)"
      />
    </template>
  </google-maps-loader>
</template>

<script>
import { mapActions } from 'vuex';

import GoogleMapsLoader from './GoogleMapsLoader';
import GoogleMapsMarker from './GoogleMapsMarker';

import { mapSettings } from '@/utils/mapSettings';

export default {
  name: 'SchoolsMap',
  components: {
    GoogleMapsLoader,
    GoogleMapsMarker,
  },
  data() {
    return {
      mapCenter: { lat: -12.03267, lng: 26.866102 },
      MAP_KEY: process.env.VUE_APP_MAP_KEY,
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOLS_MAP: 'dashboards/GET_SCHOOLS_MAP',
    }),
    infoWindow(data) {
      console.log('clicked');

      data.open(this.map, this);
    },
  },
  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      };
    },
    markers() {
      return this.$store.state.dashboards.schoolsMap;
    },
  },
  created() {
    this.GET_SCHOOLS_MAP();
  },
};
</script>
